import React, { useState } from 'react';
import axios from 'axios';
import './ExcelUpload.css';

type UploadType = 'song' | 'track';

const ExcelUpload: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploadType, setUploadType] = useState<UploadType>('song');
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState<string>('');

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      if (selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          selectedFile.type === 'application/vnd.ms-excel') {
        setFile(selectedFile);
        setMessage('');
      } else {
        setMessage('请选择Excel文件 (.xlsx 或 .xls)');
        setFile(null);
      }
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('请先选择文件');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', uploadType);

    setUploading(true);
    setMessage('');

    try {
      const response = await axios.post('/api/upload-excel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage('文件上传成功！');
      setFile(null);
    } catch (error) {
      setMessage('上传失败，请重试');
      console.error('Upload error:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="excel-upload-container">
      <h2>Excel文件上传</h2>
      <div className="form-section">
        <div className="input-group">
          <label htmlFor="uploadType">上传类型：</label>
          <select
            id="uploadType"
            value={uploadType}
            onChange={(e) => setUploadType(e.target.value as UploadType)}
            disabled={uploading}
          >
            <option value="song">歌曲数据</option>
            <option value="track">音轨数据</option>
          </select>
        </div>

        <div className="upload-section">
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            disabled={uploading}
          />
          <button 
            onClick={handleUpload}
            disabled={!file || uploading}
            className="upload-button"
          >
            {uploading ? '上传中...' : '上传'}
          </button>
        </div>
      </div>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default ExcelUpload; 